import { usePage } from "@inertiajs/react"
import type { ReactNode } from "react"
import type { SharedPageProps } from "../../types/shared"
import { AppSidebar } from "./AppSidebar"

type AppLayoutProps = {
  children: ReactNode
}

export function AppLayout({ children }: AppLayoutProps) {
  const flash = usePage<SharedPageProps>().props.flash

  return (
    <div className="flex min-h-screen bg-slate-950 text-slate-100">
      <AppSidebar />
      <main className="min-w-0 flex-1">
        {flash?.notice && (
          <div className="border-b border-emerald-900/50 bg-emerald-950/40 px-6 py-3 text-sm text-emerald-100">{flash.notice}</div>
        )}
        {flash?.alert && (
          <div className="border-b border-rose-900/50 bg-rose-950/40 px-6 py-3 text-sm text-rose-100">{flash.alert}</div>
        )}
        {children}
      </main>
    </div>
  )
}
